export const maxRowsCodeEffect = 200;
